export type TimeOfDay = "morning" | "afternoon" | "evening" | "night";

export const getTimeOfDay = (date: Date = new Date()): TimeOfDay => {
  const hour = date.getHours();
  if (hour < 12) return "morning";
  if (hour < 17) return "afternoon";
  if (hour < 21) return "evening";
  return "night";
};

export const getTimeGreeting = (date: Date = new Date()): string => {
  const timeOfDay = getTimeOfDay(date);
  if (timeOfDay === "morning") return "Good morning";
  if (timeOfDay === "afternoon") return "Good afternoon";
  if (timeOfDay === "evening") return "Good evening";
  return "Good night";
};
